export default {
  fund: {
    pageTitle: '基金产品 Fund Products',
    detailTitle: '基金详情 Fund Details',
    issueDate: '发行日期',
    fundManager: '基金管理人',
    minInvestment: '最小投资额',
    managementFee: '管理费',
    performanceFee: '业绩费',
    shareClass: '份额类别',
    statusOperating: '正常运作',
    noFunds: '暂无基金数据',
    nav: '最新净值',
    navDate: '净值日期',
    fundInfo: '基金信息',
    fundCode: '基金代码',
    fundCurrency: '基金币种',
    operatingStatus: '运作状态',
    loading: '加载中...',
  },
};
